import React, { useEffect, useState } from "react";
import { Box, Container, Grid, Paper } from "@mui/material";
import apis from "services";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import useNavigate from "hooks/Navigate";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { setWallet } from "redux/slices/walletSlicer";
import InvestOptionsModal from "components/modals/InvestOptionsModal";
import RequestWithDrawlTable from "components/datagrid/RequestWithDrawlTable";
import { setAdmin } from "redux/slices/adminSlice";

const WithDrawlRequest = () => {
  const { adminUser } = useSelector((store) => store.admin);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (adminUser) {
      setData((prevState) => ({
        ...prevState,
        type: "owner",
        balance: adminUser?.wallet?.dividend || 0,
      }));
    }
  }, [adminUser]);

  const onSelect = (e) => {
    const type = e.target.value;
    const balances = {
      owner: adminUser?.wallet?.dividend || 0,
      reserve: adminUser?.reserveWallet?.dividend || 0,
      "owner-new": adminUser?.newWallet?.dividend || 0,
    };
    setData((prevState) => ({ ...prevState, type, balance: balances[type] }));
  };

  const [withDrawl, setWithDrawl] = useState([]);

  const [data, setData] = useState({
    amount: "",
    balance: 0,
    type: "owner",
  });

  const fetchAllWithDrawladmin = async () => {
    setLoading(true);
    try {
      const res = await apis.getAllWithdrawlAdmin();
      setWithDrawl(res?.data?.withDrawl);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await fetchAllWithDrawladmin();
    })();
  }, []);

  const { rows, columns } = RequestWithDrawlTable(withDrawl);
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setData((prevState) => ({ ...prevState, [name]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    const res = await apis.addWithdrawlAdmin(data);
    if (res?.data?.status) {
      dispatch(setAdmin(res.data?.wallet));
      toast.success(res.data?.message);
      setData((prev) => ({ ...prev, amount: "" }));
      await fetchAllWithDrawladmin();
    } else {
      toast.error(res.data?.message);
      setData((prev) => ({ ...prev, amount: "" }));
    }
  };

  return (
    <>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header />
            {loading ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
              <Container sx={{ mt: 4, mb: 4 }} className="mainContainerComp">
                <div class="container-withdrawl mb-5">
                  <Grid xs={12} sm={12} md={12} lg={12} sx={{ flex: "1" }}>
                    <Paper
                      style={{ width: "100%", height: "100%" }}
                      sx={{
                        // p: 2,
                        display: "flex",
                        flexDirection: "column",
                      }}
                      className="dashboard-box-withdrawlReq"
                    >
                      <div className="boxwithdrawlReqPagebox">
                        <svg
                          width="64"
                          height="64"
                          viewBox="0 0 64 64"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_117_3783)">
                            <path
                              d="M42.6601 14.4384C42.6601 13.1933 42.6744 11.9481 42.6566 10.7047C42.637 9.43274 41.7209 8.5367 40.4431 8.54205C39.8675 8.54561 39.29 8.59549 38.7162 8.65605C30.3577 9.52715 24.2324 17.7679 25.7882 26.046C27.2977 34.0818 34.1449 39.1695 42.2859 38.302C49.5857 37.5253 55.3725 31.155 55.4651 23.7979C55.4847 22.2196 54.6364 21.3449 53.0717 21.3431C50.737 21.3396 48.4041 21.3467 46.0695 21.3413C43.9986 21.336 42.669 19.9928 42.6619 17.9068C42.6584 16.7507 42.6619 15.5946 42.6619 14.4384H42.6601ZM19.1496 55.4674C19.1638 55.3231 19.1781 55.2358 19.1781 55.1503C19.1781 45.6627 19.1852 36.175 19.1727 26.6891C19.171 24.8614 17.7808 23.4968 15.9505 23.4808C13.9509 23.463 11.9513 23.4754 9.95171 23.4772C7.64735 23.4772 6.37309 24.7563 6.37131 27.0703C6.37131 36.2908 6.37131 45.5112 6.37131 54.7317V55.4674H19.1478H19.1496ZM63.9751 59.8087H0.0231684V64.0003H63.9751V59.8087ZM55.4723 17.0731C57.561 17.0731 59.6497 17.0802 61.7384 17.0713C63.1392 17.0642 64.0178 16.1646 64.0018 14.7573C63.9964 14.2478 63.9519 13.7366 63.8966 13.2307C63.0875 5.83967 56.7679 0.0840044 49.3807 0.000279049C47.7928 -0.0175349 46.9338 0.817937 46.932 2.39625C46.9285 6.19595 46.9267 9.99566 46.9374 13.7936C46.9374 14.2567 46.9801 14.7288 47.0746 15.1813C47.3473 16.4924 48.078 17.0696 49.4057 17.0713C51.4285 17.0731 53.4495 17.0713 55.4723 17.0713V17.0731ZM38.3918 55.4674C38.3918 51.5733 38.3972 47.7558 38.39 43.9365C38.3865 41.9004 37.0409 40.5625 35.0039 40.5554C33.0274 40.5501 31.051 40.5518 29.0745 40.5554C26.9038 40.559 25.5886 41.8683 25.5868 44.0362C25.5833 47.6347 25.5868 51.2313 25.5868 54.8297V55.4674H38.3936H38.3918ZM0 4.21861H29.7981V0.0323441H0V4.21861ZM57.6037 55.4692C57.6037 53.7074 57.6109 52.0008 57.602 50.2961C57.5913 48.308 56.2386 46.9666 54.2408 46.9577C52.5085 46.9506 50.7709 47.0504 49.0475 46.9346C46.1354 46.7386 44.5635 48.292 44.7791 51.2081C44.8825 52.6136 44.797 54.0316 44.797 55.4692H57.6037ZM0.0178218 8.56342V12.7515H19.1442V8.56342H0.0178218Z"
                              fill="white"
                            />
                            <path
                              d="M42.6629 14.4384C42.6629 15.5945 42.6594 16.7507 42.6629 17.9068C42.6701 19.9928 43.9978 21.336 46.0705 21.3413C48.4051 21.3466 50.738 21.3413 53.0727 21.3431C54.6374 21.3449 55.4857 22.2195 55.4661 23.7978C55.3753 31.155 49.5867 37.5252 42.2869 38.3019C34.1459 39.1677 27.2987 34.0818 25.7892 26.046C24.2334 17.7678 30.3587 9.52712 38.7172 8.65602C39.291 8.59546 39.8685 8.54558 40.4441 8.54202C41.7202 8.53667 42.638 9.43271 42.6576 10.7046C42.6754 11.9498 42.6612 13.1932 42.6629 14.4384Z"
                              fill="#E0221E"
                            />
                            <path
                              d="M19.1497 55.4675H6.375V54.7318C6.375 45.5113 6.375 36.2908 6.375 27.0703C6.375 24.7563 7.64926 23.4791 9.95541 23.4773C11.955 23.4773 13.9546 23.4648 15.9542 23.4808C17.7845 23.4969 19.1729 24.8614 19.1764 26.6891C19.1889 36.1768 19.1818 45.6645 19.1818 55.1504C19.1818 55.2359 19.1675 55.3232 19.1533 55.4675H19.1497Z"
                              fill="#E0221E"
                            />
                            <path
                              d="M63.9753 59.8066V63.9983H0.0234375V59.8066H63.9753Z"
                              fill="#E0221E"
                            />
                            <path
                              d="M55.4727 17.0713C53.4499 17.0713 51.4289 17.0713 49.4061 17.0713C48.0784 17.0713 47.3477 16.4924 47.075 15.1813C46.9806 14.7288 46.9396 14.2567 46.9378 13.7936C46.9271 9.99388 46.9289 6.19417 46.9324 2.39625C46.9324 0.817937 47.7932 -0.0175349 49.3812 0.000279049C56.7683 0.0840044 63.0879 5.83968 63.8953 13.2271C63.9505 13.7348 63.9951 14.2443 64.0004 14.7538C64.0165 16.1611 63.1378 17.0607 61.737 17.0678C59.6483 17.0785 57.5596 17.0696 55.4709 17.0713H55.4727Z"
                              fill="#E0221E"
                            />
                            <path
                              d="M38.3935 55.4652H25.5867V54.8275C25.5867 51.229 25.5849 47.6324 25.5867 44.034C25.5885 41.8661 26.9038 40.5567 29.0745 40.5532C31.0509 40.5496 33.0273 40.5478 35.0038 40.5532C37.0408 40.5585 38.3864 41.8981 38.3899 43.9343C38.3971 47.7536 38.3917 51.5711 38.3917 55.4652H38.3935Z"
                              fill="#E0221E"
                            />
                            <path
                              d="M0 4.21849V0.0322266H29.7981V4.21849H0Z"
                              fill="#E0221E"
                            />
                            <path
                              d="M57.602 55.4691H44.7952C44.7952 54.0333 44.8808 52.6136 44.7774 51.2081C44.5618 48.2919 46.1337 46.7385 49.0458 46.9345C50.7691 47.0503 52.5068 46.9505 54.239 46.9577C56.2351 46.9666 57.5878 48.308 57.6002 50.296C57.6091 52.0008 57.602 53.7073 57.602 55.4691Z"
                              fill="#E0221E"
                            />
                            <path
                              d="M0.0195312 8.56348H19.1459V12.7515H0.0195312V8.56348Z"
                              fill="#E0221E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_117_3783">
                              <rect width="64" height="64" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <h3 className="text-center balance-withdrawl">
                        {t("labels.balance")}
                      </h3>
                      <h4 className="text-center balance-withdrawl">
                        {data?.balance?.toFixed(3)}
                      </h4>
                    </Paper>
                  </Grid>
                  <div class="content-withdrawl">
                    <h3 className="dashboard-title">
                      {t("titles.withDrawl-admin")}
                    </h3>
                    <Form onSubmit={submit} className="mt-2">
                      <Row className="d-flex  align-items-center">
                        {/* <Col xs={12} md={12} lg={4}> */}
                        <Form.Group className="mb-2" controlId="title">
                          <Form.Label>{t("titles.enter_amount")}</Form.Label>
                          <Form.Control
                            required
                            type="number"
                            name="amount"
                            placeholder={t(
                              "placeholders.enter_request_withdrawl_amount"
                            )}
                            onChange={onChangeHandler}
                            value={data.amount}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="type">
                          <Form.Label>Wallet Type</Form.Label>
                          <Form.Select
                            id="type"
                            onChange={onSelect}
                            required
                            value={data.type}
                          >
                            <option disabled>Select Wallet Balance Type</option>
                            <option value={"owner"}>Normal Wallet</option>
                            <option value={"reserve"}>Reserve Wallet</option>
                            <option value={"owner-new"}>New Wallet</option>
                          </Form.Select>
                        </Form.Group>
                        <div className="text-center w-100">
                          <Button
                            className="lp-btn mt-4 text-center w-100"
                            variant="outline-danger"
                            type="submit"
                            style={{ background: "#E0221E", color: "#fff" }}
                          >
                            {t("buttons.submit")}
                          </Button>
                        </div>
                        {/* </Col> */}
                      </Row>
                    </Form>
                  </div>
                </div>

                <Grid
                  item
                  container
                  justifyContent="flex-end"
                  className="mt-4"
                  sx={{ height: "600px", position: "relative", zIndex: "10" }}
                >
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "even"
                        : "odd"
                    }
                  />
                  <img
                    src="/assets/images/frameCardBG.png"
                    alt="frameCardBG"
                    style={{
                      position: "absolute",
                      bottom: "-46px",
                      left: "-24px",
                      width: "296px",
                      zIndex: "-1",
                    }}
                    className="card-bg-img"
                  />
                </Grid>
              </Container>
            )}
          </Box>
        </div>
      </Box>
    </>
  );
};

export default WithDrawlRequest;
